const ITEMS = [
  "Sprayed PU",
  "Seamless Membrane",
  "Solidwood",
  "Toughened Glass",
  "Acrylic",
  "Wardrobe Shutters",
  "Laminate",
  "Ceramic",
  "2400mm Panel Discipline",
  "Since 2009"
];

export default function Marquee() {
  const row = (
    <>
      {ITEMS.map((t, i) => (
        <span key={i} className="flex items-center shrink-0">
          <span className={`mx-8 sm:mx-12 whitespace-nowrap ${i % 2 === 0 ? "font-serif italic text-2xl sm:text-4xl text-ink" : "font-mono text-[10px] sm:text-xs uppercase tracking-[0.4em] text-beiged"}`}>
            {t}
          </span>
          <span className="text-beiged text-xs">◆</span>
        </span>
      ))}
    </>
  );

  return (
    <div data-testid="editorial-marquee" className="relative border-y border-ink/10 bg-bone py-6 sm:py-8 overflow-hidden">
      <div className="flex w-max animate-marquee">
        <div className="flex shrink-0 items-center">{row}</div>
        <div className="flex shrink-0 items-center" aria-hidden="true">{row}</div>
      </div>
    </div>
  );
}
